import React from "react";
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import { getBrand } from './../helper/helperSvi';
import { exceptionHandler } from './../helper/helperException';
import SVILoading from './../component/sviLoading';
import { apiReviews } from './../api/apiReviews';
import packageJson from './../../package.json';
import Switch from "react-switch";

export default function PageLayout() {
    const { locationId, guid, rating, pForm } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const [context, setContext] = React.useState(undefined)

    React.useEffect(() => {
        try {
            if (context === undefined || Object.keys(context)?.length === 0) {
                apiReviews.getLocationById({
                    locationId,
                    guid,
                    rating,
                    formId: pForm,
                })
                    .then(res => {
                        let tmpContext = res?.data

                        if (tmpContext === undefined || typeof (tmpContext) !== 'object') {
                            tmpContext = {}
                        }
                        else {
                            // Redirect URL to platforms
                            if (tmpContext?.redirectUrl) {
                                window.location.href = tmpContext.redirectUrl
                                return
                            }

                            // Check webservice
                            if (!tmpContext || typeof tmpContext !== 'object') {
                                exceptionHandler(null, "API /api/reviews/getLocationById return invaid result", {
                                    apiRequest: { locationId, guid, rating, pForm },
                                    apiResponse: tmpContext,
                                });
                            }

                            // Check missing values
                            if (!tmpContext?.source) {
                                exceptionHandler(null, "API /api/reviews/getLocationById missing 'source' in response", {
                                    apiRequest: { locationId, guid, rating, pForm },
                                    apiResponse: tmpContext,
                                });
                            }
                        }

                        // Set Brand
                        tmpContext.brand = getBrand(tmpContext?.brand ?? "")

                        // Set Language
                        const language = searchParams?.get("lang") || tmpContext?.brand?.defaultLanguage || "en";

                        // Check data
                        setContext({
                            ...tmpContext,
                            locationId,
                            guid,
                            rating,
                            pForm,
                            isEnglish: language === 'en',
                        })
                    })
                    .catch(ex => {
                        exceptionHandler(ex, "pageLayout:apiReviews.getLocationById", {
                            "API": "/api/reviews/getLocationById",
                            "locationId": locationId ?? "---",
                            "guid": guid ?? "---",
                            "rating": rating ?? "---",
                        })
                        setContext({})
                    })
            }
        }
        catch (ex2) {
            exceptionHandler(ex2, "pageLayout:apiReviews.getLocationById2", { locationId, guid, rating, pForm });
        }
    }, []);


    const handleLanguageChange = () => {
        setSearchParams({ lang: (context.isEnglish ? 'fr' : 'en') });
        setContext({ ...context, isEnglish: !context.isEnglish });
    }


    return (!context)
        ? <SVILoading />
        : <>
            {context.brand &&
                <header className="container">
                    <div className="text-end mt-5 text-muted">
                        <label>French</label>
                        <Switch
                            className="my-n2 mx-2"
                            offColor="#ced4da" //gray-500
                            onColor="#ced4da" //gray-500
                            offHandleColor="#6c757d" //gray-600
                            onHandleColor="#6c757d"  //gray-600
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 4px rgba(0, 0, 0, 0.3)"
                            activeBoxShadow="0px 0px 1px 4px rgba(0, 0, 0, 0.3)"
                            handleDiameter={22}
                            height={26}
                            width={50}
                            onChange={handleLanguageChange}
                            checked={context.isEnglish}
                        />
                        <label>English</label>
                    </div>
                    <div className="row text-center mt-5 pt-5">
                        <div className="col-8 offset-2 col-md-4 offset-md-4 col-xl-4 offset-xl-4 col-xxl-2 offset-xxl-5">

                            <img
                                src={require('./../statics/images/' + context.brand.logo)}
                                alt={context.brand.name}
                                width="100%" height="auto"
                                className="d-inline-block align-top" />
                        </div>
                    </div>
                </header>
            }
            <main className="container my-5">
                <Outlet context={[context, setContext]} />
            </main>
            <footer className="container mt-5 mb-2">
                <div className="row text-center mt-5">
                    <small className="text-muted">{context.locationName}</small>
                    <small className="text-muted">©{new Date().getFullYear()} StorageVault Canada - v{packageJson.version}</small>
                </div>
            </footer>
        </>
}
